export default {
  getCompanySkuIdentifiers: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/company_sku_identifiers/getters.js